import { render } from "./page-section.vue?vue&type=template&id=3a740d90&scoped=true"
import script from "./page-section.vue?vue&type=script&lang=js"
export * from "./page-section.vue?vue&type=script&lang=js"

import "./page-section.vue?vue&type=style&index=0&id=3a740d90&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a740d90"],['__file',"src/components/notepad/pages/page-section.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a740d90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a740d90', __exports__)) {
    api.reload('3a740d90', __exports__)
  }
  
  module.hot.accept("./page-section.vue?vue&type=template&id=3a740d90&scoped=true", () => {
    api.rerender('3a740d90', render)
  })

}


export default __exports__